import * as alertApi from './alert-api';
import alertEvents from './alert-events';

import constructDialog from '../../utils/webcomponents/construct-dialog';
import dispatchCustomEvent from '../../utils/dispatch-custom-event';
import { getTranslation } from '../../utils/webcomponents/translate';

const getEditTitle = (alert) => {
	const { alertConditionId, triggered } = alert;
	const isUpdate = alertConditionId !== null && typeof alertConditionId !== 'undefined';

	if (isUpdate) {
		return getTranslation('alerts', 'editTitle', 'Edit alert');
	}

	if (triggered) {
		return getTranslation('alerts', 'reactivateTitle', 'Reactivate alert');
	}

	return getTranslation('alerts', 'addTitle', 'Add alert');
};

class AlertMediator {
	constructor() {
		document.body.addEventListener(alertEvents.EDIT, AlertMediator.onAlertEdit);
		document.body.addEventListener(alertEvents.REMOVE, AlertMediator.onAlertRemove);
		document.body.addEventListener(alertEvents.UPDATE, AlertMediator.onAlertUpdate);
	}

	static async onAlertEdit(e) {
		const { detail: options } = e;

		const title = await getEditTitle(options);

		constructDialog({ title }, 'x-alert-edit-form', { options: JSON.stringify(options) });
	}

	static async onAlertRemove(e) {
		const { detail: options } = e;
		const title = await getTranslation('alerts', 'deleteTitle', 'Delete alert');

		constructDialog({ title }, 'x-alert-remove-form', { options: JSON.stringify(options) });
	}

	static async onAlertUpdate({ detail }) {
		try {
			await alertApi.update(JSON.stringify(detail));
		} catch (e) {
			dispatchCustomEvent(this, alertEvents.ERROR, detail);
		}
	}
}

export default new AlertMediator();
